import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import {
  FaBell,
  FaArrowRight,
  FaCalendarAlt,
  FaInfoCircle
} from 'react-icons/fa';
import config from '../../../config';
import './ModalNotificaciones.css';

const TIPO_DOC_MAP = {
  FV: 'Factura de Venta',
  EX: 'Factura de Exportación',
  NC: 'Nota Crédito',
  ND: 'Nota Débito',
  PS: 'POS',
  NE: 'Nómina Electrónica',
  NA: 'Nómina Ajuste',
  DS: 'Documento Soporte',
  NP: 'Nota Ajuste Proveedores'
};

class ModalNotificaciones extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      resolucionesAlerts: [],
      noticias: [],
      loading: true
    };
  }

  componentDidMount() {
    this.loadAllAlerts();
  }

  loadAllAlerts = () => {
    if (typeof window === 'undefined' || !window.sessionStorage) {
      this.setState({ loading: false });
      return;
    }

    const company = sessionStorage.getItem('company');
    const tipo = sessionStorage.getItem('tipo');

    if (!company) {
      this.setState({ loading: false });
      return;
    }

    const reqOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        empresa: company,
        tipo: tipo || '--'
      }
    };

    // 1. Consultar alertas de resoluciones
    const fetchResoluciones = fetch(config.servBackEnd + '/resoluciones/alerts', reqOptions)
      .then((res) => res.json())
      .then((data) => {
        if (data && data.ok && Array.isArray(data.data)) {
          return data.data;
        } else if (Array.isArray(data)) {
          return data;
        }
        return [];
      })
      .catch((err) => {
        console.error('Error cargando alertas de resoluciones:', err);
        return [];
      });

    // 2. Consultar noticias generales del sistema
    const fetchNoticias = fetch(config.servBackEnd + '/notice/listnotice')
      .then((res) => res.json())
      .then((data) => {
        if (data && data.ok && Array.isArray(data.data)) {
          return data.data;
        } else if (Array.isArray(data)) {
          return data;
        }
        return [];
      })
      .catch((err) => {
        console.error('Error cargando noticias:', err);
        return [];
      });

    Promise.all([fetchResoluciones, fetchNoticias]).then(([resAlerts, notices]) => {
      const totalAvisos = resAlerts.length + notices.length;
      const yaVistos = sessionStorage.getItem('gtic_avisos_vistos') === 'true';

      this.setState({
        resolucionesAlerts: resAlerts,
        noticias: notices,
        loading: false,
        // Si hay avisos y aún no se han visto en esta sesión, abrir modal automáticamente
        show: totalAvisos > 0 && !yaVistos
      });
    });
  };

  handleOpen = () => {
    this.setState({ show: true });
  };

  handleClose = () => {
    sessionStorage.setItem('gtic_avisos_vistos', 'true');
    this.setState({ show: false });
  };

  formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  render() {
    const { show, resolucionesAlerts, noticias } = this.state;
    const totalCount = resolucionesAlerts.length + noticias.length;
    const hasExpiredRes = resolucionesAlerts.some((a) => a.DIAS_RESTANTES < 0);

    return (
      <React.Fragment>
        {/* Botón Disparador de Notificaciones en Barra (Siempre visible) */}
        <button
          type="button"
          className="modal-avisos-trigger-btn"
          onClick={this.handleOpen}
          title="Ver notificaciones del sistema"
        >
          <FaBell className="modal-avisos-trigger-icon" />
          {totalCount > 0 && (
            <span className={`modal-avisos-trigger-badge ${hasExpiredRes ? 'badge--danger' : 'badge--warning'}`}>
              {totalCount}
            </span>
          )}
        </button>

        {/* Modal General de Notificaciones */}
        <Modal
          show={show}
          onHide={this.handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
          dialogClassName="modal-avisos-dialog"
        >
          <div className="modal-avisos-card">
            {/* Header del Modal */}
            <div className="modal-avisos-header">
              <div className="modal-avisos-header-left">
                <div className="modal-avisos-icon-circle">
                  <FaBell />
                </div>
                <h4 className="modal-avisos-title">Notificaciones</h4>
              </div>
              <button
                type="button"
                className="modal-avisos-btn-close"
                onClick={this.handleClose}
                aria-label="Cerrar modal"
              >
                &times;
              </button>
            </div>

            {/* Body del Modal */}
            <div className="modal-avisos-body">
              {/* Sección 1: Resoluciones */}
              {resolucionesAlerts.length > 0 && (
                <div className="modal-avisos-section">
                  <div className="modal-avisos-list">
                    {resolucionesAlerts.map((item, idx) => {
                      const docLabel = TIPO_DOC_MAP[item.TIPO_DOCUMENTO] || item.TIPO_DOCUMENTO;
                      const prefijoText = item.PREFIJO ? ` · Prefijo: ${item.PREFIJO}` : '';
                      const dias = parseInt(item.DIAS_RESTANTES, 10);
                      const isExpired = dias < 0;

                      let estadoText = '';
                      if (dias > 0) {
                        estadoText = `Vence en ${dias} ${dias === 1 ? 'día' : 'días'}`;
                      } else if (dias === 0) {
                        estadoText = '¡Vence el día de hoy!';
                      } else {
                        estadoText = `Vencida hace ${Math.abs(dias)} ${Math.abs(dias) === 1 ? 'día' : 'días'}`;
                      }

                      return (
                        <div
                          key={item.ID_RESOLUCION || idx}
                          className="modal-avisos-item-card"
                        >
                          <span className="modal-avisos-item-bar" />
                          <div className="modal-avisos-item-content">
                            <div className="modal-avisos-item-header">
                              <span className="modal-avisos-item-name">
                                Res. N° {item.RESOLUCION || 'S/N'} · {docLabel}{prefijoText}
                              </span>
                            </div>
                            <div className="modal-avisos-item-meta">
                              <span>
                                <FaCalendarAlt style={{ marginRight: '4px', verticalAlign: '-1px' }} />
                                Fecha de Vencimiento: <strong>{this.formatDate(item.FECHA_FINAL)}</strong>
                              </span>
                            </div>
                          </div>
                          <div className="modal-avisos-item-action">
                            <span className={`modal-avisos-pill ${isExpired ? 'pill--danger' : 'pill--warning'}`}>
                              {estadoText}
                            </span>
                            <a
                              href="/configuration/resoluciones"
                              className="modal-avisos-btn-action"
                              title="Gestionar en el módulo de resoluciones"
                            >
                              <span>Gestionar</span>
                              <FaArrowRight style={{ marginLeft: '5px' }} />
                            </a>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Sección 2: Noticias Generales del Sistema */}
              {noticias.length > 0 && (
                <div className="modal-avisos-section">
                  <div className="modal-avisos-list">
                    {noticias.map((noticia, idx) => (
                      <div key={noticia.ID_NOTICIA || idx} className="modal-avisos-item-card">
                        <span className="modal-avisos-item-bar bar--info" />
                        <div className="modal-avisos-item-content">
                          <div className="modal-avisos-item-header">
                            <span className="modal-avisos-item-name">{noticia.TITULO_NOTICIA}</span>
                          </div>
                          <p className="modal-avisos-notice-text">{noticia.DESCRIPCION_NOTICIA}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Empty state si no hay avisos */}
              {totalCount === 0 && (
                <div className="modal-avisos-empty">
                  <FaInfoCircle style={{ fontSize: '32px', color: '#94a3b8', marginBottom: '8px' }} />
                  <p>No tienes notificaciones pendientes en este momento.</p>
                </div>
              )}
            </div>

            {/* Footer del Modal */}
            <div className="modal-avisos-footer">
              <Button
                variant="primary"
                className="modal-avisos-btn-confirm"
                onClick={this.handleClose}
              >
                Entendido
              </Button>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

export default ModalNotificaciones;



// WEBPACK FOOTER //
// ./src/components/widgets/alerts/ModalNotificaciones.jsx